import Typography from "@mui/material/Typography";


const SubTitle = ({text, sx}) => {
    return (
        <Typography variant="h6" component="h3" sx={sx}>
          {text}
        </Typography>
    );
}

export default SubTitle;